import React, { ReactNode } from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Button from '@components/UI-KIT/Button';

// Icons
import {
    Write,
    More
} from '@/assets/icons';

// Styles
import './EmptyState.scss';
import VARIABLES from '@/assets/variables';

interface Props {
    title: string | ReactNode;
    imagePath: string;
    buttons?: {
        buttonLabel: string;
        action: () => void;
        iconName?: 'Write' | 'More';
        buttonLevel?: 1 | 2 | 3 | 4;
        subtitle: string | ReactNode;
    }[];
}

const EmptyState: React.FC<Props> = ({
    title,
    imagePath,
    buttons = []
}) => {

    return (
        <>
            <Grid
                container
                alignItems="flex-start"
                justify="center"
                direction="column"
                className="AOL-Empty-page-container"
            >
                <Grid
                    item
                    xs={5}
                >
                    <img
                        src={imagePath}
                        alt="Empty State"
                    />
                    <Typography
                        className="AOL-Empty-page-title"
                        variant="h4"
                        color="primary-dark"
                    >
                        {title}
                    </Typography>
                    { (buttons.length) ? (
                        buttons.map(extraButton => (
                            <Grid >
                                { typeof extraButton.subtitle === 'string' ? (
                                    <Typography
                                        className="AOL-Empty-page-subtitle"
                                    >
                                        {extraButton.subtitle}
                                    </Typography>
                                ) : extraButton.subtitle }
                                <Button
                                    label={extraButton.buttonLabel}
                                    className="AOL-Empty-page-retry-button"
                                    onClick={extraButton.action}
                                    level={extraButton.buttonLevel}
                                    icon={(
                                        extraButton.iconName === 'Write' ? (
                                            <Write
                                                color={VARIABLES.palette.secondary_color}
                                            />
                                        ) : extraButton.iconName === 'More' && (
                                            <More
                                                color={VARIABLES.palette.secondary_color}
                                            />
                                        )
                                    )}
                                />
                            </Grid>
                        ))
                    ) : ''}
                </Grid>
            </Grid>
        </>
    );
};

export default EmptyState;